module.exports = __webpack_public_path__ + "static/media/dashboard-3.4d5fd2c7.svg";